module.exports = __webpack_public_path__ + "img/s1v4t2.1f0329a4.jpeg";